import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import DefaultLayout from '@/components/Layout/Layout';
import Home from '@/pages/Home/Home';
import InfoPlace from '@/pages/InfoPlace/InfoPlace';
import Team from '@/pages/Team/Team';
import Portfolio from '@/pages/Portfolio/Portfolio';
import InfoPlaceDetail from '@/pages/InfoPlaceDetail/InfoPlaceDetail';
const router = createBrowserRouter([
	{
		element: <DefaultLayout />,
		children: [
			{ path: '/', element: <Home /> },
			{ path: '/infoplace', element: <InfoPlace /> },
			{ path: '/infoplace/detail/:id', element: <InfoPlaceDetail /> },
			{ path: '/team', element: <Team /> },
			{ path: '/portfolio', element: <Portfolio /> },
		],
	},
]);

const Router = () => (
	<RouterProvider
		router={router}
		future={{
			v7_startTransition: true,
		}}
	/>
);

export default Router;
